module.exports = __webpack_public_path__ + "img/1.03c08cc3.png";